export default __webpack_public_path__ + "static/media/minecraft.9e1b7400.png";